/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbTypeEvaluationDto
 */
export interface FcbTypeEvaluationDto {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeEvaluationDto
     */
    idevaluationType?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeEvaluationDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeEvaluationDto
     */
    actif?: boolean;
}

/**
 * Check if a given object implements the FcbTypeEvaluationDto interface.
 */
export function instanceOfFcbTypeEvaluationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeEvaluationDtoFromJSON(json: any): FcbTypeEvaluationDto {
    return FcbTypeEvaluationDtoFromJSONTyped(json, false);
}

export function FcbTypeEvaluationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeEvaluationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idevaluationType': !exists(json, 'idevaluationType') ? undefined : json['idevaluationType'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbTypeEvaluationDtoToJSON(value?: FcbTypeEvaluationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idevaluationType': value.idevaluationType,
        'libelle': value.libelle,
        'actif': value.actif,
    };
}

